:host {
  max-width: 100%;
}

.component {
  height: inherit;
  position: relative; // for arrows
  overflow-x: hidden;

  &.is-touchscreen {
    .scrollable {
      overflow-x: auto;

      // Hide scrollbar on iOS Safari and Android Chrome
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  .scrollable {
    height: inherit;
  }

  sdx-arrow {
    position: absolute;
    top: 0;
    width: 40px;

    &.left {
      left: 0;
    }

    &.right {
      right: 0;
    }
  }
}
